module.exports = __webpack_public_path__ + "static/thomas-vimare-IZ01rjX0XQA-unsplash-2c59404afeaa4a7fa2bec02c3da439cf.jpg";